<template lang="pug">
    td
        template(v-if="exceedsStringLimit")
            StrLimitTooltipText(:text="text" :char-limit="charLimit" :alt-tooltip="altTooltip")
        template(v-else-if="validText")
            | {{ text }}
        template(v-else)
            | ---

</template>

<script lang="ts">
import Vue from 'vue';

// Components
import StrLimitTooltipText from "@/components/shared/str_limit_tooltip_text.vue";

export default Vue.extend({
    data() {
        return {
            stringLimit: 25,
        }
    },
    methods: {
        setStringLimit() {
            if (this.charLimit > 0) {
                return this.stringLimit = this.charLimit;
            }
        },
    },
    computed: {
        displayTooltip() {
            if (this.altTooltip?.length > 0) {
                return this.altTooltip;
            }

            return this.text;
        },
        exceedsStringLimit() {
            return this.text?.length > this.stringLimit;
        },
        validText() {
            return this.text?.length > 0
        }
    },
    props: {
        altTooltip: String,
        charLimit: Number,
        text: String,
    },
    created() {
        this.setStringLimit();
    },
    components: {
        StrLimitTooltipText
    },
});
</script>

<style lang="scss" scoped>
</style>